// HOC component that renders either a Link or Button based on disabled prop
// When disabled is true, renders a button; otherwise renders a Link
// All other props and children are passed through as-is

import React from 'react';
import Link from 'next/link';

const LinkWithButton = ({
  disabled,
  children,
  onClickAtDisabled,
  ...props
}) => {
  if (disabled) {
    return (
      <button
        type="button"
        disabled={onClickAtDisabled ? false : disabled}
        className={`${props.className || ''}  opacity-50`}
        {...props}
        onClick={onClickAtDisabled}
      >
        {children}
      </button>
    );
  }

  return <Link {...props}>{children}</Link>;
};

export default LinkWithButton;
